/*
 * Author: Chao.Wang
 * File Created: Monday, 25-01-06 07:43 pm
 * Last Modified: Monday, 25-03-17 03:18 pm, by Harper Yan
 */

import { useState } from 'react';
import Link from 'next/link';
import { Trans, useTranslation } from 'next-i18next';
import { Box, Button, Checkbox } from '@mui/material';
import type { DrawerDialogProps } from '@ucard/ds/message/dialog/templates';
import { DrawerDialog } from '@ucard/ds/message/dialog/templates';
import type { Agreement } from '@/@types/agreement';
import { StyledConfirmText, StyledContent, StyledDialogTitle } from './style';
export interface ConfirmAgreementDialogProps extends DrawerDialogProps {
  onConfirm: () => void;
  showClose: boolean;
  open: boolean;
  agreementInfo: Agreement;
  disableBackdropClose: boolean;
}
const ConfirmAgreementDialog = ({
  onConfirm,
  agreementInfo,
  ...props
}: ConfirmAgreementDialogProps) => {
  const {
    t
  } = useTranslation('common');
  const [confirmStatus, setConfirmStatus] = useState(false);
  const handleChangeConfirmStatus = () => {
    setConfirmStatus(preStatus => !preStatus);
  };
  return <DrawerDialog {...props} data-sentry-element="DrawerDialog" data-sentry-component="ConfirmAgreementDialog" data-sentry-source-file="index.tsx">
      <Box p="32px 20px 28px 20px" sx={{
      display: 'flex',
      flexDirection: 'column'
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <StyledDialogTitle data-sentry-element="StyledDialogTitle" data-sentry-source-file="index.tsx">
          {t('terms-conditions-update.title')}
        </StyledDialogTitle>

        <StyledContent data-sentry-element="StyledContent" data-sentry-source-file="index.tsx">
          <Trans components={{
          1: <Link className="primary" href={agreementInfo.url} target="_blank" />
        }} i18nKey="terms-conditions-update.content" data-sentry-element="Trans" data-sentry-source-file="index.tsx" />
        </StyledContent>

        <Box onClick={handleChangeConfirmStatus} sx={{
        display: 'flex',
        alignItems: 'center'
      }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Checkbox checked={confirmStatus} disableRipple data-sentry-element="Checkbox" data-sentry-source-file="index.tsx" />
          <StyledConfirmText data-sentry-element="StyledConfirmText" data-sentry-source-file="index.tsx">
            {t('terms-conditions-update.confirm-text')}
          </StyledConfirmText>
        </Box>

        <Button disabled={!confirmStatus} fullWidth onClick={onConfirm} sx={{
        mt: '10px',
        height: '40px'
      }} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          {t('terms-conditions-update.confirm-btn')}
        </Button>
      </Box>
    </DrawerDialog>;
};
export default ConfirmAgreementDialog;